
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Card from 'vux/src/components/card/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import MatchSimpleUnstart from './matchSimpleUnstart.vue'

export default {
props: {
dayInfo: Object
},
components: {
Flexbox,
FlexboxItem,
Divider,
XButton,
MatchSimpleUnstart
},
mounted(){

this.reload();
},
methods: {
getRoundName (roundType, roundNum, roundTitle) {
var roundName = "--";

if(roundType=='cup_1'){
roundName = "决赛"
}
else if(roundType=='cup_2'){
roundName = "半决赛"
}
else if(roundType=='cup_4'){
roundName = "1/4决赛"
}
else if(roundType=='cup_8'){
roundName = "1/8决赛"
}
else if(roundType=='cup_16'){
roundName = "1/16决赛"
}
else if(roundType=='cup_32'){
roundName = "1/32决赛"
}
else if(roundType=='cup_64'){
roundName = "1/64决赛"
}
else if(roundType=='cup_128'){
roundName = "1/128决赛"
}
else if(roundType=='cup_team'||roundType=='league'){
roundName = "第"+roundNum+"轮"
}
else if(roundType== 'customized_rank_round'){
roundName = roundTitle
} else {
var arr = roundType.split("_")
roundName = +arr[3]+"-"+arr[2]+"名排位赛"
}
return roundName;
},
reload(){
this.title = this.genTitle();
this.matches = this.dayInfo.matches;
},
genTitle(){
var chnNumChar = ["一","二","三","四","五","六","日"];
var date = "";
if(this.dayInfo.date) {
date = this.dayInfo.date;
}
var weekday = "";
if(this.dayInfo.weekday && this.dayInfo.weekday>=1 && this.dayInfo.weekday<=7) {
weekday = " 周" + chnNumChar[this.dayInfo.weekday-1]
}
return date+weekday;
},
viewRoundDetail(){
alert(this.genTitle())
}
},
data () {
return {
title:" ",
matches:[],
}
},
watch: {
dayInfo(curVal, oldVal){
this.reload();
}
}
}



// WEBPACK FOOTER //
// ./src/components/league/roundCardUnstart.vue